// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-on-hire-status-form > * {
    margin-bottom: 30px;
  }
  .container-on-hire-status-form textarea {
    padding: 20px;
    border: 1px solid var(--color-grayscale-5);
    width: 600px;
    height: 200px;
    outline: none;
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/OnHireEntry/features/Form/style.css"],"names":[],"mappings":"AACE;IACE,mBAAmB;EACrB;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,aAAa;EACf","sourcesContent":[".container-on-hire-status-form {\n  & > * {\n    margin-bottom: 30px;\n  }\n\n  textarea {\n    padding: 20px;\n    border: 1px solid var(--color-grayscale-5);\n    width: 600px;\n    height: 200px;\n    outline: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
